import { render } from "./TemplateStampBook.vue?vue&type=template&id=d414683c&scoped=true"
import script from "./TemplateStampBook.vue?vue&type=script&lang=js"
export * from "./TemplateStampBook.vue?vue&type=script&lang=js"

import "./TemplateStampBook.vue?vue&type=style&index=0&id=d414683c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d414683c"

export default script